const Index = () => import("./index.vue");

export default [
  {
    path: "/merge/products",
    component: Index,
  },
];
